import dynamic from 'next/dynamic';

export const DynamicFilterSettingsMobilePopovers = dynamic(
  () =>
    import(/* webpackChunkName: 'FilterSettingsMobilePopovers' */ './FilterSettingsMobilePopovers'),
  {
    ssr: false,
  },
);
